import { render, staticRenderFns } from "./activity-details.vue?vue&type=template&id=61218bc6&"
import script from "./activity-details.vue?vue&type=script&lang=js&"
export * from "./activity-details.vue?vue&type=script&lang=js&"
import style0 from "./activity-details.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "activity-details.vue"
export default component.exports